var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Merge Pasien Details")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-3" }, [
        _c("h4", { staticClass: "mb-3" }, [_vm._v("Data Pasien Aktif")]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("\n                    Data Pasien\n                "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-striped" }, [
              _c(
                "tbody",
                [
                  _vm._l(_vm.detail_pasien, function (pasien, idx) {
                    return [
                      !_vm.isExcludedField(idx)
                        ? _c("tr", { key: idx }, [
                            _c("td", [_vm._v(_vm._s(idx))]),
                            _vm._v(" "),
                            _c("td", [_vm._v(_vm._s(pasien))]),
                          ])
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-9" }, [
        _c("h4", { staticClass: "mb-3" }, [_vm._v("Data Pasien Merge")]),
        _vm._v(" "),
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-header text-white bg-primary" }, [
            _vm._v("\n                    Merged Pasien\n                "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table table-striped mt-3" }, [
              _vm._m(0),
              _vm._v(" "),
              _vm.merged_pasiens.length > 0
                ? _c(
                    "tbody",
                    _vm._l(_vm.merged_pasiens, function (pasien) {
                      return _c("tr", { key: pasien.Medrec }, [
                        _c("td"),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(pasien.Medrec))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(pasien.Firstname))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(pasien.Bod))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(pasien.NoIden))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(pasien.AskesNo))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(pasien.tgl_daftar))]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-success",
                              on: {
                                click: function ($event) {
                                  return _vm.unMergePasien(pasien.Medrec)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                                        UnMerge\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ])
                    }),
                    0
                  )
                : _c("tbody", [_vm._m(1)]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-3" }, [
          _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2" }, [
            _c("div", { staticClass: "mb-3 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label text-end",
                  attrs: { for: "tanggal_dari" },
                },
                [
                  _vm._v(
                    "\n                            Dari\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.tanggal_dari,
                      expression: "filter.tanggal_dari",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "date",
                    name: "tanggal_dari",
                    id: "tanggal_dari",
                  },
                  domProps: { value: _vm.filter.tanggal_dari },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filter, "tanggal_dari", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-2" }, [
            _c("div", { staticClass: "mb-3 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-4 col-form-label text-end",
                  attrs: { for: "tanggal_sampai" },
                },
                [
                  _vm._v(
                    "\n                            Sampai\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.tanggal_sampai,
                      expression: "filter.tanggal_sampai",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "date",
                    name: "tanggal_sampai",
                    id: "tanggal_sampai",
                  },
                  domProps: { value: _vm.filter.tanggal_sampai },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.filter,
                        "tanggal_sampai",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-5" }, [
            _c("div", { staticClass: "mb-3 row" }, [
              _c(
                "label",
                {
                  staticClass: "col-sm-6 col-form-label text-end",
                  attrs: { for: "search" },
                },
                [
                  _vm._v(
                    "\n                            No. RM/Nama/NIK/No Kartu BPJS\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.search,
                      expression: "filter.search",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", name: "search", id: "search" },
                  domProps: { value: _vm.filter.search },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filter, "search", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-3" }, [
            _c("div", { staticClass: "mb-3" }, [
              _c("div", { staticClass: "col-sm-8 text-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    on: { click: _vm.resetFilters },
                  },
                  [
                    _c("i", { staticClass: "fa fa-refresh" }),
                    _vm._v(
                      "\n                                Reset\n                            "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.getAllPasien },
                  },
                  [
                    _c("i", { staticClass: "fa fa-search" }),
                    _vm._v(
                      "\n                                Cari\n                            "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(2),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "modal_merge_pasien",
        staticClass: "modal",
        attrs: { tabindex: "-1" },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog",
            staticStyle: { width: "80vw", "max-width": "80vw" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        { staticClass: "card-header text-white bg-primary" },
                        [
                          _vm._v(
                            "\n                                    Data Pasien Aktif\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("table", { staticClass: "table table-striped" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.detail_pasien, function (pasien, idx) {
                                return [
                                  !_vm.isExcludedField(idx)
                                    ? _c("tr", { key: idx }, [
                                        _c("td", [_vm._v(_vm._s(idx))]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.detail_pasien[idx],
                                                expression:
                                                  "\n                                                                detail_pasien[\n                                                                    idx\n                                                                ]\n                                                            ",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              name: idx,
                                              id: `detail-${idx}`,
                                              readonly: "",
                                            },
                                            domProps: {
                                              value: _vm.detail_pasien[idx],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.detail_pasien,
                                                  idx,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c(
                                            "div",
                                            { staticClass: "form-check" },
                                            [
                                              _c("input", {
                                                staticClass: "form-check-input",
                                                attrs: {
                                                  type: "radio",
                                                  name: `input-${idx}`,
                                                  id: `input-${idx}-1`,
                                                  checked: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.setMergedData(
                                                      idx,
                                                      pasien
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        { staticClass: "card-header text-white bg-primary" },
                        [
                          _vm._v(
                            "\n                                    Data Pasien Merge\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("table", { staticClass: "table table-striped" }, [
                          _vm._m(5),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(
                                _vm.data_pasien_merge,
                                function (pasien, idx) {
                                  return [
                                    !_vm.isExcludedField(idx)
                                      ? _c("tr", { key: idx }, [
                                          _c("td", [_vm._v(_vm._s(idx))]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.data_pasien_merge[idx],
                                                  expression:
                                                    "\n                                                                data_pasien_merge[\n                                                                    idx\n                                                                ]\n                                                            ",
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                name: idx,
                                                id: `merge-${idx}`,
                                                readonly: "",
                                              },
                                              domProps: {
                                                value:
                                                  _vm.data_pasien_merge[idx],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.data_pasien_merge,
                                                    idx,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "form-check" },
                                              [
                                                _c("input", {
                                                  staticClass:
                                                    "form-check-input",
                                                  attrs: {
                                                    type: "radio",
                                                    name: `input-${idx}`,
                                                    id: `input-${idx}-2`,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setMergedData(
                                                        idx,
                                                        pasien
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ])
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-sm-4" }, [
                    _c("div", { staticClass: "card" }, [
                      _c(
                        "div",
                        { staticClass: "card-header text-white bg-primary" },
                        [
                          _vm._v(
                            "\n                                    Data Pasien Merged\n                                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "card-body" }, [
                        _c("table", { staticClass: "table table-striped" }, [
                          _vm._m(6),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              _vm._l(_vm.data_merged, function (pasien, idx) {
                                return [
                                  !_vm.isExcludedField(idx)
                                    ? _c("tr", { key: idx }, [
                                        _c("td", [_vm._v(_vm._s(idx))]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.data_merged[idx],
                                                expression:
                                                  "\n                                                                data_merged[\n                                                                    idx\n                                                                ]\n                                                            ",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "text",
                                              name: idx,
                                              id: `merged-${idx}`,
                                            },
                                            domProps: {
                                              value: _vm.data_merged[idx],
                                            },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.$set(
                                                  _vm.data_merged,
                                                  idx,
                                                  $event.target.value
                                                )
                                              },
                                            },
                                          }),
                                        ]),
                                      ])
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button", "data-bs-dismiss": "modal" },
                  },
                  [
                    _vm._v(
                      "\n                        Batal\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.goMergePasien(_vm.data_pasien_merge.Medrec)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Simpan Merge Data\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("No Rekam Medis")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tanggal Lahir")]),
        _vm._v(" "),
        _c("th", [_vm._v("NIK")]),
        _vm._v(" "),
        _c("th", [_vm._v("No Kartu BPJS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tanggal Daftar")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cek")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("tr", [
      _c("td", { attrs: { colspan: "8" } }, [_vm._v("Data tidak ditemukan")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-header text-white bg-primary" }, [
        _vm._v("\n                    List Pasien\n                "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table-pasien" } }),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Merge Pasien")]),
      _vm._v(" "),
      _c("button", {
        staticClass: "btn-close",
        attrs: {
          type: "button",
          "data-bs-dismiss": "modal",
          "aria-label": "Close",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Field")]),
        _vm._v(" "),
        _c("th", [_vm._v("Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Use")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Field")]),
        _vm._v(" "),
        _c("th", [_vm._v("Value")]),
        _vm._v(" "),
        _c("th", [_vm._v("Use")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Field")]),
        _vm._v(" "),
        _c("th", [_vm._v("Value")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }